import api from "@/services/api"
import { ref } from "vue"
import { useNotification } from "@/composables"

export const useStates = () => {
    const { showError } = useNotification()

    const apiStates = ref([])
    const setApiStates = (value) => {
        apiStates.value = value
    }

    const fetchingStates = ref(false)
    const setFetchingStates = (value) => {
        fetchingStates.value = value
    }

    const fetchStates = async (countryId) => {
        try {
            setFetchingStates(true)
            const response = await api.get(`/countries/${countryId}/states`)
            setApiStates(response.data.data)
        } catch (error) {
            console.error(error)
            showError("Failed to fetch states")
        } finally {
            setFetchingStates(false)
        }
    }

    return {
        apiStates,
        fetchStates,
        fetchingStates
    }
}